// extracted by mini-css-extract-plugin
module.exports = {"login":"SocialLogin_login__381Jr"};